/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import { withLoadingAsync, showToast } from '../../services/common-service'
import { getBucketVariable, storeBucketVariable } from '../../services/bucket-service'
import { deleteAllVariables, setVariable } from '../../services/context-service'
import BlipPortalToastTypes from '../../constants/blip-portal-toast-types'
import styles from './styles.module.scss';

const Jaula = () => {
    const [jaulaData, setJaulaData] = useState([]);
    const [contato, setContato] = useState("");
    const [motivo, setMotivo] = useState("");
    const [masterState, setMasterState] = useState("");
    const [masterStateEdited, setMasterStateEdited] = useState(false);
    const [stateId, setStateId] = useState("");
    const [stateIdEdited, setStateIdEdited] = useState(false);
    const [flowId, setFlowId] = useState("");
    const [flowIdEdited, setFlowIdEdited] = useState(false);

    useEffect(() => {
        LoadJaulaAsync();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        // eslint-disable-next-line
    }, [jaulaData])

    const LoadJaulaAsync = async () => {
        const bucketJaula = await getBucketVariable("Jaula-Data-Plugin")
        console.log(bucketJaula)
        if (!bucketJaula) {
            await storeBucketVariable("Jaula-Data-Plugin", { "jaula": [], "masterState": masterState, "flowId": flowId ,"stateId": stateId })
        } else {
            setJaulaData(bucketJaula["jaula"])
            setMasterState(bucketJaula["masterState"])
            setStateId(bucketJaula["stateId"])
            setFlowId(bucketJaula["flowId"])
        }
        showToast(BlipPortalToastTypes.SUCCESS, 'Jaula carregada com sucesso')
    }

    const deleteJaulaData = (index) => {
        setJaulaData(jaulaData => {
            if (jaulaData.length > 1) {
                let updatedList = [...jaulaData]
                updatedList.splice(index, 1)
                storeBucketVariable("Jaula-Data-Plugin", { "jaula": updatedList, "masterState": masterState, "flowId": flowId ,"stateId": stateId })
                return updatedList
            } else {
                storeBucketVariable("Jaula-Data-Plugin", { "jaula": [], "masterState": masterState, "flowId": flowId ,"stateId": stateId })
                return []
            }
        })
    }

    const newJaula = async (item) => {
        setJaulaData(jaulaData => {
            const updatedList = [...jaulaData]
            updatedList.push(item)
            storeBucketVariable("Jaula-Data-Plugin", { "jaula": updatedList, "masterState": masterState, "flowId": flowId ,"stateId": stateId })
            setVariable(item.Identity, "master-state", `${masterState}@msging.net`)
            setVariable(item.Identity, `stateid@${flowId}`, stateId)
            return updatedList
        })
    }

    const updateJaula = async () => {
        setJaulaData(jaulaData => {
            storeBucketVariable("Jaula-Data-Plugin", { "jaula": jaulaData, "masterState": masterState, "flowId": flowId ,"stateId": stateId })
            return jaulaData
        })
    }
    return (
        <>
            <div className="ph1 ph4-m ph5-ns mt2">
                <div className="flex justify-between mb2">
                    <div className="flex justify-start w-30">
                        <div className="items-center pt3">
                            <bds-typo variant="fs-24" >
                                Jaula
                            </bds-typo>
                        </div>
                    </div>
                    <div className="flex justify-start items-center w-60">
                    <div className="ml2 w-30">
                        <bds-input
                            label="ID Contato"
                            id="ID Contato"
                            value=""
                            onInput={(e) => {
                                setContato(e.target.value)
                            }}
                        />
                    </div>
                    <div className="ml2 w-50">
                        <bds-input
                            label="Motivo"
                            id="Motivo"
                            value=""
                            onInput={(e) => {
                                setMotivo(e.target.value)
                            }}
                        />
                    </div>
                    <div className="ml2">
                        <bds-button-icon
                            variant="secondary"
                            size="standard"
                            icon="plus"
                            onClick={async () => {
                                await newJaula({
                                    "Identity": contato,
                                    "Motivo": motivo,
                                    "Data": "",
                                    "Usuario": ""
                                })
                            }}
                        />
                    </div>
                </div>
                    <div className="flex justify-end items-center w-10">
                        <div className="ml2">
                            <bds-button
                                variant="outline"
                                color="primary"
                                size="standard"
                                icon-left="refresh"
                                onClick={() => {
                                    withLoadingAsync(async () => {
                                    })
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="flex">
                    <div className='w-50'>
                        <div className={styles['variable-list']}>
                            <bds-paper elevation="static">
                                {jaulaData?.map((item, index) => (
                                    <div className="flex justify-between items-center">
                                            <div
                                                className='pointer ml2 w-100'
                                                onClick={() => {
                                                }}
                                            >
                                                <bds-typo variant="fs-16" id={"texto " + index}>
                                                    {item.Identity} - {item.Motivo}
                                                </bds-typo>
                                            </div>
                                        <div className="flex justify-end items-center">
                                            <div className=''>
                                                <bds-button-icon
                                                    icon="refresh-all"
                                                    id={"delete " +index}
                                                    variant="secondary"
                                                    size="short"
                                                    onClick={() => {
                                                        deleteJaulaData(index)
                                                        deleteAllVariables(item.Identity)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </bds-paper>
                        </div>
                    </div>
                    <div className='w-50'>
                        <bds-paper elevation="static">
                            <div className='pa3'>
                                <bds-typo variant="fs-20" >
                                    Configuração da jaula
                                </bds-typo>
                                <div className="flex justify-start items-center mb3 w-100">
                                    <bds-input
                                        label="ID Servico"
                                        id="ID Servico"
                                        value={masterState}
                                        disabled={!masterStateEdited}
                                        onInput={(e) => {
                                            setMasterState(e.target.value)
                                        }}
                                    />
                                    {!masterStateEdited &&
                                        <div className="ml2">
                                            <bds-button-icon
                                                variant="secondary"
                                                size="standard"
                                                icon="edit"
                                                onClick={() => {
                                                    setMasterStateEdited(true)
                                                }}
                                            />
                                        </div>
                                    }
                                    {masterStateEdited &&
                                        <div className="flex justify-end items-center ml2">
                                            <bds-button-icon
                                                variant="secondary"
                                                size="standard"
                                                icon="save-disk"
                                                onClick={() => {
                                                    setMasterStateEdited(false)
                                                    updateJaula()
                                                }}
                                            />
                                            <bds-button-icon
                                                variant="secondary"
                                                size="standard"
                                                icon="close"
                                                onClick={() => {
                                                    setMasterStateEdited(false)
                                                }}
                                            />
                                        </div>
                                    }
                                </div>
                                <div className="flex justify-start items-center mb3 w-100">
                                    <bds-input
                                        label="ID Fluxo"
                                        id="ID Fluxo"
                                        value={flowId}
                                        disabled={!flowIdEdited}
                                        onInput={(e) => {
                                            setFlowId(e.target.value)
                                        }}
                                    />
                                    {!flowIdEdited &&
                                        <div className="ml2">
                                            <bds-button-icon
                                                variant="secondary"
                                                size="standard"
                                                icon="edit"
                                                onClick={() => {
                                                    setFlowIdEdited(true)
                                                }}
                                            />
                                        </div>
                                    }
                                    {flowIdEdited &&
                                        <div className="flex justify-end items-center ml2">
                                            <bds-button-icon
                                                variant="secondary"
                                                size="standard"
                                                icon="save-disk"
                                                onClick={() => {
                                                    setFlowIdEdited(false)
                                                    updateJaula()
                                                }}
                                            />
                                            <bds-button-icon
                                                variant="secondary"
                                                size="standard"
                                                icon="close"
                                                onClick={() => {
                                                    setFlowIdEdited(false)
                                                }}
                                            />
                                        </div>
                                    }
                                </div>
                                <div className="flex justify-start items-center mb3 w-100">
                                    <bds-input
                                        label="ID Bloco"
                                        id="ID Bloco"
                                        value={stateId}
                                        disabled={!stateIdEdited}
                                        onInput={(e) => {
                                            setStateId(e.target.value)
                                        }}
                                    />
                                    {!stateIdEdited &&
                                        <div className="ml2">
                                            <bds-button-icon
                                                variant="secondary"
                                                size="standard"
                                                icon="edit"
                                                onClick={() => {
                                                    setStateIdEdited(true)
                                                }}
                                            />
                                        </div>
                                    }
                                    {stateIdEdited &&
                                        <div className="flex justify-end items-center ml2">
                                            <bds-button-icon
                                                variant="secondary"
                                                size="standard"
                                                icon="save-disk"
                                                onClick={() => {
                                                    setStateIdEdited(false)
                                                    updateJaula()
                                                }}
                                            />
                                            <bds-button-icon
                                                variant="secondary"
                                                size="standard"
                                                icon="close"
                                                onClick={() => {
                                                    setStateIdEdited(false)
                                                }}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        </bds-paper>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Jaula
